import script from "./FooterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBar.vue?vue&type=script&setup=true&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=44744fde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44744fde"]])

export default __exports__